import * as types from "./types";

export const history = {
  namespaced: true,

  state: {
    length: 0,
    index: 0,
  },
  getters: {
  },
  mutations: {
    setLength(state, length) {
      state.length = length;
    },
    setIndex(state, index) {
      state.index = index;
    }
  },
  actions: {
    [types.SET_INDEX]({ commit }, index) {
      commit("setIndex", index);
    },
    [types.SET_LENGTH]({ commit }, length) {
      commit("setLength", length);
    }
  }
};
